import { injectable, inject } from 'inversify'

import { AuthService } from '#Auth/services'
import { useAuthStore } from '#Auth/store'

@injectable()
export class AuthSupport {
  protected store: ReturnType<typeof useAuthStore>

  constructor(
    @inject(AuthService)
    readonly service: AuthService,
  ) {
    this.store = useAuthStore()
  }

  checkAuth() {
    return Boolean(this.store.token)
  }

  checkIsAnonymous() {
    return Boolean(this.store.session?.isAnon)
  }

  async loadAuthConfig() {
    const currentConfig = this.store.config
    if (currentConfig) return currentConfig

    this.store.setConfig(await this.service.getConfig())

    return this.store.config
  }

  /**
   * @deprecated Mini App has no guest session (ADR mini-app-auth-on-launch).
   */
  async createAnonimSession() {
    return this.service.createAnonimSession()
  }
}
